import type { FieldPermissionGrant } from '@record-fill';

import type { PermissionSubject, PermissionSubjectMode } from '../composables/usePermissionSubjects';
import type { FormElement } from '../model/form.types';
import { iterateFormElements } from './form-element-traversal';
import { fieldLabel } from './permissions-submit-check';

const emptyGrant: FieldPermissionGrant = {
  fieldId: '',
  positionIds: [],
  functionalActivityIds: [],
};

export interface PermissionFieldGroup {
  id: number;
  name: string;
  fieldLabels: string[];
}

export function buildPermissionFieldGroups(
  mode: PermissionSubjectMode,
  subjects: readonly PermissionSubject[],
  grantsByFieldId: Readonly<Record<string, FieldPermissionGrant>>,
  elements: readonly FormElement[]
): PermissionFieldGroup[] {
  const grantedIds = (grant: FieldPermissionGrant) =>
    mode === 'positions' ? grant.positionIds : grant.functionalActivityIds;

  const orderedFields = [...iterateFormElements(elements, { includeTableContainers: true })];

  return subjects
    .map((subject) => ({
      id: subject.id,
      name: subject.name,
      fieldLabels: orderedFields
        .filter((element) => grantedIds(grantsByFieldId[element.id] ?? emptyGrant).includes(subject.id))
        .map((element) => fieldLabel(element, element.id)),
    }))
    .filter((group) => group.fieldLabels.length > 0);
}
